import React, { useEffect, useState } from 'react'
import { View, Text, StyleSheet, TouchableOpacity, Image, Alert } from 'react-native'
import { fetchAuthSession } from 'aws-amplify/auth'
import { getConection } from '../appBar/context/HeaderContext'
import { STATUS_PERIOD, STATUS_KEYS, STATUS_MODERATION } from './constants/constants.stores'
import { request_get_schedule_period } from '../../services/schedule.services'
import { EvilIcons, Feather, Ionicons } from '@expo/vector-icons'
import theme from '../../../theme'
import styles from './CreateScheduleHomeStyles'
import { ScrollView } from 'react-native-gesture-handler'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { Loader } from '../customUtils/Components/Loader'
import type { CreateScheduleSingleModel, Period, Week } from './models/CreateScheduleModel'

export const CreateScheduleHome = () => {
    const { isConnected, hasInternet } = getConection()
    const [loading, setLoading] = useState(true)
    const [periods, setPeriods] = useState<Period[] | null>(null)
    // const [weeks, setWeeks] = useState([])
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()

    useEffect(() => {
        const unsubscribe = navigation.addListener('focus', () => {
            setLoading(true)
            {
                fetchData()
            }
        })
        return unsubscribe
    }, [navigation])

    const fetchData = async () => {
        try {
            if (isConnected && hasInternet) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ""
                const data: CreateScheduleSingleModel = await request_get_schedule_period({ authToken })
                if (!data) {
                    setLoading(false)
                    return
                }
                if (data) {
                    setPeriods(data.periods)
                    // setWeeks(data.period ? data.period.weeks : [])
                }

                setLoading(false)
            }
        } catch (error) {
            console.log('error', error)
            setLoading(false)
        }
    }

    const handleMonthPress = (period: Period) => {
        if (period && period.status != STATUS_PERIOD.PERIOD_APROBB) {
            navigation.navigate('CreateSchedule', { week_id: null, period_id: period._id })
        }
    }

    const handleWeekPress = (weekId: string, period: Period) => {
        navigation.navigate('CreateSchedule', { week_id: weekId, period_id: period._id })
    }

    const renderWeekButton = (week: Week, weeks: Week[], index: number, period: Period) => {
        let newWeeks = [...weeks]

        const lastApprovedWeekIndex = newWeeks.reduce((lastIndex, week, idx) => {
            return week.status === 1 || week.status === 4 || week.status === 8 ? idx : lastIndex
        }, -1)

        // habilito la primera si no hay ninguna aprobada
        if (lastApprovedWeekIndex === -1) {
            // si no hay ninguna aprobada y no hay ninguna con status 1, paso a 3
            if (newWeeks.findIndex((week) => week.status === 1) === -1) {
                newWeeks[0].status = 3
            }
        } else {
            // Habilito la siguiente a la ultima aprobada
            if (lastApprovedWeekIndex + 1 < newWeeks.length) {
                newWeeks[lastApprovedWeekIndex + 1].status = 3
            }
        }

        let foundPendingWeek = false
        newWeeks = newWeeks.map((week) => {
            if (week.status === 1 || week.status === 4 || week.status === 8) {
                // Mantén el status
                return week
            } else if (week.status === 3 && !foundPendingWeek) {
                // Mantengo la primer semana pendiente
                foundPendingWeek = true
                return week
            } else {
                // Deshabilito las demas
                week.status = 0
                return week
            }
        })
        const isActive =
            period &&
            period.status == STATUS_PERIOD.PERIOD_APROBB &&
            (newWeeks[index].status == 1 || newWeeks[index].status == 3 || newWeeks[index].status == 4 || newWeeks[index].status == 8)
        const buttonStyle = styles.weekButtonInactive
        const buttonTextStyle =
            isActive && week.status == 3
                ? [{ ...styles.weekButtonTextActive }, { color: theme.colors.colorSecondary }]
                : isActive
                ? styles.weekButtonTextActive
                : styles.weekButtonTextInactive

        // const today = new Date() // Fecha actual
        // today.setUTCHours(0, 0, 0, 0) // Establecer la hora a las 00:00 en UTC
        // const dateFinish = new Date(week.date_finish) // Fecha de finalización de la semana
        // dateFinish.setUTCHours(0, 0, 0, 0) // Establecer la hora a las 00:00 en UTC
        // if (dateFinish < today) {
        //     return (
        //         //Semana ya finalizada
        //         <View key={week._id}>
        //             <View style={styles.weekButtonInactive}>
        //                 <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', alignSelf: 'center' }}>
        //                     <Text style={styles.weekButtonTextInactive}>{`${week.name_week}`}</Text>
        //                     <Ionicons name='lock-closed-outline' color={theme.colors.lightGray} size={18} style={styles.marginLeft} />
        //                 </View>
        //             </View>
        //         </View>
        //     )
        // }
        return (
            <View key={week._id}>
                <TouchableOpacity
                    style={buttonStyle}
                    onPress={() => (isActive ? handleWeekPress(week._id, period) : {})}
                    disabled={!isActive ? true : false}
                >
                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', alignSelf: 'center' }}>
                        <Text style={buttonTextStyle}>{`${week.name_week}`}</Text>
                        {renderIconWeek(week, isActive)}
                    </View>
                </TouchableOpacity>
                <View style={{ height: 4 }}></View>
            </View>
        )
    }

    const renderIconWeek = (week: Week, isActive) => {
        let color = isActive && week.status == 3 ? theme.colors.colorSecondary : theme.colors.colorPrimary
        const size = 18

        switch (week.status) {
            case STATUS_PERIOD.PERIOD_APROBB:
                return <Ionicons name='checkmark-outline' size={size} color={color} style={styles.marginLeft} />
            case STATUS_PERIOD.PENDING_APPROBB_WEEKS:
                return <Ionicons name='time-outline' size={size} color={color} style={styles.marginLeft} />
            case STATUS_PERIOD.PENDING_SET_WEEKS:
                return <Ionicons name='arrow-forward-outline' size={size} color={color} style={styles.marginLeft} />
            case 0:
                color = theme.colors.lightGray
                return <Ionicons name='lock-closed-outline' size={size} color={color} style={styles.marginLeft} />
            default:
                return <></>
        }
    }

    const renderMonthButton = (period: Period) => {
        let periodName = period?.schedule_period_name ?? ''
        let dateInit = period?.date_init ?? ''
        let newDate = new Date(dateInit)
        let year = newDate.getFullYear() ?? ''
        let enableMonth = (period && period.status != STATUS_PERIOD.PERIOD_APROBB) || false

        return (
            <TouchableOpacity
                style={!enableMonth ? [styles.monthlyButtonInactive, styles.flexDirectionRow] : styles.monthlyButtonActive}
                onPress={() => {
                    enableMonth ? handleMonthPress(period) : {}
                }}
                disabled={!enableMonth ? true : false}
            >
                <Text style={!enableMonth ? styles.monthlyBorderButtonText : styles.monthlyButtonTextActive}>
                    {/*Armar agenda*/}
                    {periodName + ' ' + year}
                </Text>
                {!enableMonth && <Feather name='check' size={18} color={theme.colors.darkGray} style={styles.marginLeft} />}
            </TouchableOpacity>
        )
    }
    if (loading) {
        return <Loader />
    }
    // const currentDate = new Date()
    // const monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    // const currentMonth = monthNames[currentDate.getMonth()]
    // const currentYear = currentDate.getFullYear()

    return (
        <View style={styles.container}>
            <ScrollView contentContainerStyle={{ flexGrow: 1, justifyContent: 'center' }} showsVerticalScrollIndicator={false}>
                {/* textos */}
                <>
                    <Image style={styles.image} source={require('../../../assets/createAgenda.png')} />
                    <View style={styles.spacer2}></View>
                    <Text style={[styles.title, styles.paddingHorizontal]}>
                        ¡Ya puedes armar tu agenda!
                        {/*periodName + ' ' + year}*/}
                    </Text>
                    <View style={styles.spacer1}></View>
                    <View style={styles.spacer1}></View>
                    <Text style={[styles.description, styles.paddingHorizontal]}>
                        Al completar la planificación mensual, se habilitarán los botones para organizar y asignar las actividades de las semanas. ¡Manos
                        a la obra!
                    </Text>
                    <View style={styles.spacer1}></View>
                    <View style={styles.spacer1}></View>
                    <View style={styles.spacer2}></View>
                </>

                {periods &&
                    periods.length > 0 &&
                    periods.map((period, periodIndex) => (
                        <React.Fragment key={periodIndex}>
                            {renderMonthButton(period)}
                            {period.weeks &&
                                period.weeks.map((week, weekIndex) => (
                                    <React.Fragment key={weekIndex}>{renderWeekButton(week, period.weeks, weekIndex, period)}</React.Fragment>
                                ))}
                        </React.Fragment>
                    ))}
            </ScrollView>
        </View>
    )
}
